import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 财务概览
export const dashBoard = params => {
    return get("/admin/contracts/dashboard", params);
};
// 监控列表
export const payNodes = params => {
    return get("/admin/contracts/paymentNodes", params);
};
// 操作已支付
export const payDone = params => {
    return put(`/admin/contracts/paymentNodes/${params}/paid`);
};

// 合同列表
export const htList = params => {
    return get("/admin/contracts", params);
};

// 添加合同
export const htAdd = params => {
    return post("/admin/contracts", params);
};

// 修改合同
export const htEdit = params => {
    return put(`/admin/contracts/${params.id}`, params);
};

// 删除合同
export const htDel = params => {
    return del(`/admin/contracts/${params}`, params);
};

// 小区列表
export const xqList = params => {
    return get("/admin/xiaoqus/xqList", params);
};
//公司列表
export const companyList = params => {
	return get("/admin/xiaoqus/companyList", params);
};
// 风禾简牍的置业顾问列表
export const gwList = params => {
	return get("/admin/xiaoqus/staffList", params);
};


// WEBPACK FOOTER //
// ./src/api/hetong.js